export const ThemeTypes = {
  CHANGE_THEME: "CHANGE_THEME",
  SET_ACTIVE_THEMES: "SET_ACTIVE_THEMES",
  SET_ACTIVE_THEME: "SET_ACTIVE_THEME"
};
